import React from 'react';
import { useTranslation } from 'react-i18next';
import star from '../assets/images/star.png';
import BeamsBackground from './micro/BeamsBackground';
import Linkedin from '../assets/svg/linkedin.svg';
import Insta from '../assets/svg/insta.svg';

import '../styles/footer-cta.scss';

const FooterCTA = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-cta" id="contact">
      <div className="footer-cta__background">
        <BeamsBackground
          beamWidth={2}
          beamHeight={20}
          beamNumber={14}
          lightColor="#ffffff"
          speed={1.6}
          noiseIntensity={1.1}
          scale={0.12}
          rotation={8}
        />
        <div className="footer-cta__mask" />
      </div>

      <div className="footer-cta__inner section-shell">
        <div className="footer-cta__headline" id="about">
          <p className="footer-cta__eyebrow">{t('footer.eyebrow')}</p>
          <h2>{t('footer.title')}</h2>
          <p>
            {t('footer.description')}
          </p>
        <div className="footer-cta__ctaRow">
          <a href="/contact" className="footer-cta__button btn btn--primary">
            <span className="btn__icon">    
              <img src={star} alt="" />
            </span>
            <span>{t('footer.cta_primary')}</span>
          </a>
          <a href="/services" className="footer-cta__button btn btn--ghost">
            <span>{t('footer.cta_secondary')}</span>
          </a>
        </div>
        </div>

        <div className="footer-cta__nav">
          <div className="footer-cta__brand">Yves Web Design</div>
          <nav>
            <a href="/portfolio">{t('footer.nav_customers')}</a>
            <a href="/services">{t('footer.nav_tech')}</a>
            <a href="/about">{t('footer.nav_about')}</a>
            <a href="/contact">{t('footer.nav_contact')}</a>
          </nav>
        </div>

        <div className="footer-cta__meta">
          <div>
            <p>info@yveswebdesign.com</p>
            <div className="footer-cta__socials">
              <a href="https://www.linkedin.com/company/yves-webdesign" target="_blank" rel="noreferrer">
                <img src={Linkedin} alt="Linkedin" />
              </a>
              <a href="https://www.instagram.com/yves.webdesign/" target="_blank" rel="noreferrer">
                <img src={Insta} alt="Instagram" />
              </a>
            </div>
          </div>
          <div>
            <p>{t('footer.privacy')}</p>
            <span>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterCTA;
